import { CoordinatorService } from './coordinator.service';
import { Document } from './document';

export class ScriptDocument {
    #coords: CoordinatorService;
    #document: Document;

    constructor(coords: CoordinatorService, doc: Document) {
        this.#coords = coords;
        this.#document = doc;
    }

    get title() {
        return this.#document.title;
    }

    display(isEdit = false) {
        if (isEdit) this.#coords.notepad$.current = this.#document;
        else this.#coords.reader$.current = this.#document;
    }
}
